import { signInWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore"; // Added Firestore imports
import React, { useState, useEffect} from "react";
import logo from "../../stock/nexus/logo.png"
import { NavLink } from "react-router-dom";
import { auth, txtdb } from "../../firebase-config"; // Imported txtdb
import { useNavigate } from "react-router-dom";
import { PiHandWavingFill, PiEye, PiEyeSlash } from "react-icons/pi";
import { ImSpinner8 } from "react-icons/im";
import { PuffLoader } from "react-spinners";
   
function Login() {
  //error state
  const [errorMessage, setErrorMessage] = useState("");
  
  //hide/show pasword
  const [showPassword, setShowPassword] = useState(false);
  
  const navigate = useNavigate();

  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [error, setError] = useState("");

  const allowedUid = "XJOqScE2IegEsiwtZvox7Jonsqi1";
  
  const login = async (event) => {
    event.preventDefault();
    setIsLoggedIn(true);
  
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        loginEmail,
        loginPassword
      );
      const user = userCredential.user;
  
      if (user.emailVerified) {
        console.log("Sign in successful!");
  
        // Check if the user has admin access
        if (user.uid === allowedUid) {
          console.log("Admin access!");
          setError(false);
          setIsLoggedIn(false);
          navigate('/all-users'); // Or your main admin route
        } else {
          console.log("Customer access! Checking KYC status...");
          
          // --- NEW KYC CHECK LOGIC ---
          const kycRef = doc(txtdb, "kycInfo", user.uid);
          const kycSnap = await getDoc(kycRef);
          
          setIsLoggedIn(false); // Stop spinner before navigating

          if (kycSnap.exists()) {
            const kycStatus = kycSnap.data().status;
            
            if (kycStatus === "pending") {
              navigate("/verify-account/pendingApproval");
            } else if (kycStatus === "approved") {
              navigate("/dashboard");
            } else {
              // If status is rejected or missing, route back to KYC
              navigate("/verify-account/kyc"); 
            }
          } else {
            // Document doesn't exist, meaning they haven't filled out the form
            navigate("/verify-account/kyc");
          }
          // ---------------------------
        }
  
      } else {
        await sendEmailVerification(user)
        setIsLoggedIn(false)
        navigate('/verify-account/kyc')
        console.log('email not verified')
      }
  
    } catch (error) {
      setIsLoggedIn(false);
      
      if (error.code === 'auth/invalid-credential') {
        setError('Invalid email or password');
      } else if (error.code === 'auth/user-not-found') {
        setError('User not found. Please check your email.');
      } else if (error.code === 'auth/network-request-failed') {
        setError('Network Error');
      } else {
        // console.log(`Error: ${error.message}`);
      }
    }
  };
    
  //loader
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.title = "Login - NEXUS FORGE FX";

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500); // Added a small delay so the loader actually shows for a split second

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="login-page">
      {isLoading ? (
        <div className="spinner-container">
          <PuffLoader color=" #888" size={25} />
        </div>
      ) : (
        <div className="login-page-container">
          <div className="login-left">

          <NavLink to='/' className="logo-container">
              <img src={logo} alt="keystonecapitals" />
              <div className="name"><h3>NEXUS</h3><p>FORGE FX</p></div>
              </NavLink>

            <h1>
              Welcome Back! <PiHandWavingFill className="wave-icon" />
            </h1>
            <p className="loginP">Enter login details to continue investing</p>
          

            <form className="login-form">
              <div className="emailnpassword">
                <h2>Email</h2>
                <input
                  className="email-input"
                  type="email"
                  placeholder="Email"
                  onChange={(event) => {
                    setLoginEmail(event.target.value);
                  }}
                  required
                />
              </div>
          <div className="emailnpassword" style={{ position: "relative" }}>
                <h2>Password</h2>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  onChange={(event) => {
                    setLoginPassword(event.target.value);
                  }}
                  required
                />
                <div 
                  className="toggle-password" 
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <PiEyeSlash /> : <PiEye />}
                </div>
              </div>

              <div className="forgot-pass">
                <NavLink to='/reset'>Forgot password?</NavLink>
              </div>

              <button onClick={login} className="login-btn" disabled={isLoggedIn}>
              {isLoggedIn ? (
                <ImSpinner8 className="login-spinner" />
              ) : (
                "Sign In"
              )}
            </button>

              {error && <p className="passcheck">{error}</p>}
  
              {errorMessage && <p className="passcheck" style={{ color: "red", fontWeight: 500}}>{errorMessage}</p>}

              <p className="sign-up-link">
                Don't have an account? <NavLink to="/signup">Sign Up</NavLink>
              </p>
            </form>
          </div>

          <div className="login-right"></div>
        </div>
      )}
    </div>
  );
}

export default Login;